<template>
  <v-navigation-drawer
    v-model="drawer"
    :rail="rail"
    permanent
    @click="rail = false"
  >
    <v-list density="compact" nav v-click-outside="onClickOutside">
      <!-- Guest Test User View: Access ONLY to their workspace -->
      <template v-if="isUsuarioTestador">
        <v-tooltip text="Meu Workspace" location="right">
          <template #activator="{ props }">
            <router-link
              to="/workspace-convidado"
              style="text-decoration: none; color: inherit"
            >
              <v-list-item
                v-bind="props"
                exact
                to="/workspace-convidado"
                prepend-icon="mdi-briefcase-account"
                title="Meu Workspace"
                value="workspace_convidado"
                active-class="active-item"
              ></v-list-item>
            </router-link>
          </template>
        </v-tooltip>
      </template>

      <!-- Standard Team User View -->
      <template v-else>
        <v-tooltip text="Projetos" location="right">
          <template #activator="{ props }">
            <router-link
              to="/projects"
              style="text-decoration: none; color: inherit"
            >
              <v-list-item
                v-bind="props"
                exact
                to="/projects"
                prepend-icon="mdi-file-document"
                title="Projetos"
                value="projects"
                active-class="active-item"
              ></v-list-item>
            </router-link>
          </template>
        </v-tooltip>
        <div v-if="isCoord">
          <v-tooltip text="Usuários" location="right">
            <template #activator="{ props }">
              <router-link
                to="/users"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item
                  v-bind="props"
                  exact
                  to="/users"
                  prepend-icon="mdi-account-multiple"
                  title="Usuários"
                  value="users"
                  active-class="active-item"
                ></v-list-item>
              </router-link>
            </template>
          </v-tooltip>
        </div>
        <div v-if="isCoord">
          <v-tooltip text="Equipes" location="right">
            <template #activator="{ props }">
              <router-link
                to="/team"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item
                  v-bind="props"
                  exact
                  to="/team"
                  prepend-icon="mdi-account-group"
                  title="Equipe"
                  value="team"
                  active-class="active-item"
                ></v-list-item>
              </router-link>
            </template>
          </v-tooltip>
        </div>
        <div v-if="isCoord">
          <v-tooltip text="Avaliações" location="right">
            <template #activator="{ props }">
              <router-link
                to="/ratings"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item
                  v-bind="props"
                  prepend-icon="mdi-chart-bar"
                  title="Avaliações"
                  value="ratings"
                  active-class="active-item"
                ></v-list-item>
              </router-link>
            </template>
          </v-tooltip>
        </div>
        <div v-if="isCoord">
          <v-tooltip text="Validações" location="right">
            <template #activator="{ props }">
              <router-link
                to="/validations"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item
                  v-bind="props"
                  prepend-icon="mdi-playlist-check"
                  title="Validações"
                  value="validations"
                  active-class="active-item"
                ></v-list-item>
              </router-link>
            </template>
          </v-tooltip>
        </div>

        <div v-if="isCoord">
          <v-tooltip text="Formulários de Validação" location="right">
            <template #activator="{ props }">
              <router-link
                to="/gestao-formularios-validacao"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item
                  v-bind="props"
                  prepend-icon="mdi-file-document-edit-outline"
                  title="Formulários Validação"
                  value="formulario_validacao"
                  active-class="active-item"
                ></v-list-item>
              </router-link>
            </template>
          </v-tooltip>
        </div>

        <v-tooltip text="Requisitos" location="right">
          <template #activator="{ props }">
            <router-link
              :to="'/projects/' + this.idProjeto + '/Requisitos/'"
              style="text-decoration: none; color: inherit"
            >
              <v-list-item
                exact
                v-bind="props"
                prepend-icon="mdi-cogs"
                title="Requisitos"
                value="requirements"
                active-class="active-item"
              ></v-list-item>
            </router-link>
          </template>
        </v-tooltip>

        <template v-if="verificarProjeto()">
          <v-divider></v-divider>
          <v-tooltip text="Casos de uso" location="right">
            <template #activator="{ props }">
              <router-link
                :to="'/projects/' + this.idProjeto + '/CasoUso/'"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item
                  prepend-icon="mdi-copyright"
                  v-bind="props"
                  title="Casos de Uso"
                  value="casosdeuso"
                  active-class="active-item"
                ></v-list-item>
              </router-link>
            </template>
          </v-tooltip>
          <v-tooltip text="StakeHolders" location="right">
            <template #activator="{ props }">
              <router-link
                :to="'/projects/' + this.idProjeto + '/StackHolderE/'"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item
                  prepend-icon="mdi-account-key"
                  v-bind="props"
                  title="Stakeholders E."
                  value="stackholders"
                  active-class="active-item"
                ></v-list-item>
              </router-link>
            </template>
          </v-tooltip>

          <v-tooltip text="Atores" location="right">
            <template #activator="{ props }">
              <router-link
                :to="'/projects/' + this.idProjeto + '/ator/'"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item
                  v-bind="props"
                  prepend-icon="mdi-odnoklassniki"
                  title="Atores"
                  value="atores"
                  active-class="active-item"
                ></v-list-item>
              </router-link>
            </template>
          </v-tooltip>

          <v-tooltip text="Charters" location="right">
            <template #activator="{ props }">
              <router-link
                :to="'/projects/' + this.idProjeto + '/Charters/'"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item
                  v-bind="props"
                  prepend-icon="mdi-clipboard-outline"
                  title="Charters"
                  value="charters"
                  active-class="active-item"
                ></v-list-item>
              </router-link>
            </template>
          </v-tooltip>

          <v-tooltip text="Bugs" location="right">
            <template #activator="{ props }">
              <router-link
                :to="'/projects/' + this.idProjeto + '/Bugs/'"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item
                  exact
                  v-bind="props"
                  prepend-icon="mdi-bee"
                  title="Bugs"
                  value="bugs"
                  active-class="active-item"
                ></v-list-item>
              </router-link>
            </template>
          </v-tooltip>

          <v-tooltip text="Testes Independentes" location="right">
            <template #activator="{ props }">
              <router-link
                :to="'/projects/' + this.idProjeto + '/testesIndependentes/'"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item
                  v-bind="props"
                  prepend-icon="mdi-clipboard-check-multiple-outline"
                  title="Testes Independentes"
                  value="testesindependentes"
                  active-class="active-item"
                ></v-list-item>
              </router-link>
            </template>
          </v-tooltip>

          <v-tooltip text="Testes de Equipe" location="right">
            <template #activator="{ props }">
              <router-link
                :to="'/projects/' + this.idProjeto + '/testesEquipe/'"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item
                  v-bind="props"
                  prepend-icon="mdi-clipboard-check-multiple"
                  title="Testes de Equipe"
                  value="testesequipe"
                  active-class="active-item"
                ></v-list-item>
              </router-link>
            </template>
          </v-tooltip>

          <v-tooltip
            text="Escopo de Validação"
            location="right"
            v-if="isDev || isCoord"
          >
            <template #activator="{ props }">
              <router-link
                :to="'/projects/' + this.idProjeto + '/validation-scope/'"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item
                  v-bind="props"
                  prepend-icon="mdi-application-brackets"
                  title="Escopo Validação"
                  value="validation_scope"
                  active-class="active-item"
                ></v-list-item>
              </router-link>
            </template>
          </v-tooltip>

          <v-tooltip
            text="Roteiros de Validação"
            location="right"
            v-if="isScrum || isTestador || isDev || isCoord"
          >
            <template #activator="{ props }">
              <router-link
                :to="'/projects/' + this.idProjeto + '/roteiros/'"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item
                  v-bind="props"
                  prepend-icon="mdi-script-text-outline"
                  title="Roteiros"
                  value="roteiros"
                  active-class="active-item"
                ></v-list-item>
              </router-link>
            </template>
          </v-tooltip>

          <v-tooltip
            text="Resultados da Validação"
            location="right"
            v-if="isScrum || isTestador || isDev || isCoord"
          >
            <template #activator="{ props }">
              <router-link
                :to="'/projects/' + this.idProjeto + '/resultados-roteiros/'"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item
                  v-bind="props"
                  prepend-icon="mdi-chart-box-outline"
                  title="Resultados"
                  value="resultados"
                  active-class="active-item"
                ></v-list-item>
              </router-link>
            </template>
          </v-tooltip>

          <v-tooltip text="Convites de Usuários" location="right">
            <template #activator="{ props }">
              <router-link
                :to="'/projects/' + this.idProjeto + '/test-users/'"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item
                  v-bind="props"
                  prepend-icon="mdi-email-multiple"
                  title="Convites de Usuários"
                  value="convites"
                  active-class="active-item"
                ></v-list-item>
              </router-link>
            </template>
          </v-tooltip>
        </template>
      </template>

      <v-divider></v-divider>
      <v-tooltip
        :text="rail ? 'Expandir barra' : 'Recolher barra'"
        location="right"
      >
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            :class="{ 'remove-icon': !rail }"
            prepend-icon="mdi-chevron-double-right"
            title="Recolher barra"
            nav
          >
            <template #append>
              <v-btn
                variant="text"
                icon="mdi-chevron-double-left"
                @click.stop="rail = !rail"
              ></v-btn>
            </template>
          </v-list-item>
        </template>
      </v-tooltip>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import '@/assets/css/fonts.css';
import { ClickOutside } from 'vuetify/lib/directives';

export default {
  /* eslint-disable */
  directives: {
    'click-outside': ClickOutside,
  },
  /**
   * Retorna um objeto contendo os dados iniciais da aplicação.
   * @returns {Object} - Um objeto contendo as seguintes propriedades:
   *  - drawer: Um booleano que controla se o menu lateral está aberto ou fechado.
   *  - items: Um array contendo os itens do menu lateral, cada um representado por um objeto com as propriedades "title" (título do item) e "icon" (ícone do item).
   *  - rail: Um booleano que controla se a barra lateral direita está visível ou oculta.
   */
  data() {
    return {
      drawer: true,
      items: [
        { title: 'Dashboard', icon: 'mdi-home-city' },
        { title: 'Projetos', icon: 'mdi-account' },
        { title: 'Usuários', icon: 'mdi-account-group-outline' },
        { title: 'Avaliações', icon: 'mdi-account-group-outline' },
        { title: 'Casos de Uso', icon: 'mdi-cube' },
        { title: 'Requisitos', icon: 'mdi-file-cogs' },
        { title: 'Bugs', icon: 'mdi-bee' },
      ],
      rail: true,
      idProjeto: null,
    };
  },

  computed: {
    isDev() {
      return this.$store.state.funcao === 'Desenvolvedor';
    },
    isCoord() {
      return this.$store.state.funcao === 'Coordenador';
    },
    isScrum() {
      return this.$store.state.funcao === 'Scrum Master';
    },
    isTestador() {
      return this.$store.state.funcao === 'Testador';
    },
    isUsuarioTestador() {
      return localStorage.getItem('usuarioTestador') === 'sim';
    },
  },

  methods: {
    /**
     * Verifica se o id do projeto está presente na rota.
     *
     * @returns {Boolean} True, se idProjeto está na rota; false, caso contrário
     */
    verificarProjeto() {
      const { idProjeto } = this.$route.params;
      if (idProjeto) {
        this.idProjeto = idProjeto;
        return true;
      }
      return false;
    },
    onClickOutside() {
      this.rail = true;
    },
  },
};
</script>

<style>
body {
  font-family: 'Poppins', sans-serif;
}
.active-item {
  border-right: 5px solid #004984;
}
.remove-icon .v-list-item__prepend {
  visibility: hidden;
}
</style>
